import { FC } from 'react';
import HeaderNavs from '../components/headers/nav';
import Leaderboard from '../components/arena/Leaderboard';

const LeaderboardPage: FC = () => {
  return (
    <div className="min-h-screen bg-[#0B1622] text-white">
      <HeaderNavs />
      <div className="container mx-auto px-4 py-16">
        <Leaderboard />
      </div>
    </div>
  );
};

export default LeaderboardPage; 